import React from 'react';
import ClientList from '../components/clients/ClientList';
import Layout from '../components/layout/Layout';

const HomePage = () => {
  return (
    <Layout>
      <ClientList />
    </Layout>
  );
};

export default HomePage;
